import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import loaderAnimation from '../../../assets/lotties/loaderEdify.json';
import styles from './LoaderAnimation.module.scss';

interface LoaderAnimationProps {
  isActive: boolean;
  type?: 'login' | 'logout' | 'onboarding' | 'register' | 'invite';
}

const LoaderAnimation: React.FC<LoaderAnimationProps> = ({ isActive, type = 'login' }) => {
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    if (isActive) {
      const timer = setTimeout(() => {
        setShowText(true);
      }, 500);
      
      return () => clearTimeout(timer);
    } else {
      setShowText(false);
    }
  }, [isActive]);

  if (!isActive) return null;

  const getMessage = () => {
    switch (type) {
      case 'register':
        return 'Creando tu cuenta';
      case 'onboarding':
        return 'Guardando tu perfil';
      case 'logout':
        return 'Cerrando sesión';
      case 'invite':
        return 'Ingresando como invitado';
      case 'login':
      default:
        return 'Preparando tu cuenta';
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <Lottie 
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
          style={{ width: 180, height: 80 }}
        />
        <p className={`${styles.text} ${showText ? styles.textVisible : ''}`}>
          {getMessage()}<span className={styles.dots}>...</span>
        </p>
      </div>
    </div>
  );
};

export default LoaderAnimation;
